import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import { checkPageTitle } from '../../../../store/actions/authentication';
import { AppState } from '../../../../store';
import config from '../../../../config';

import Routes from '../../routes';

import { IButton } from '../../../../styles/styles';

const DocumentMain: React.FC = (props: any) => {
  const authType: string = useSelector((state: AppState) => state.Authorization.authType);
  const publicUrl = process.env.PUBLIC_URL;
  const { providerId } = useParams<{providerId: string}>();

  useEffect(() => {
    checkPageTitle(props);
  },[props])

  let menuLink = {
    new: publicUrl + "/document/create",
    myDocuments: publicUrl + "/document/list"
  }

  if(authType === config.userTypeAdmin) {
    menuLink.new = `${publicUrl}/document/${providerId}/create`;
    menuLink.myDocuments = `${publicUrl}/document/${providerId}/list`;
  }

  if(providerId !== "all") {
    return (
      <React.Fragment>
        <Link to={menuLink.new}>
          <IButton width={100}>NOVO</IButton>
        </Link>
        <Link to={menuLink.myDocuments}>
          <IButton width={210}>MEUS DOCUMENTOS</IButton>
        </Link>
        <Routes />
      </React.Fragment>
    )
  } else {
    return <Routes />
  }
  
}

export default DocumentMain;
